import AuthApi from "@/services/auth-api";
import Swal from "sweetalert2";

class FirebaseAuthBackend {
    constructor() {
        
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email, password, name, supplierCode ) => {
        return new Promise((resolve, reject) => {

            AuthApi.register(email, password, name, supplierCode)
            .then(response => {

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

                document.cookie = 'token' + "=" + response.token + ";" + "10000" + ";path=/;"   +    'domain='                   + cookieDomain + ';'      ; 
                document.cookie = 'rtoken' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"    +    'domain='          + cookieDomain + ';'      ;
                document.cookie = 'authUser' + "=" + response.username + ";" + "10000" + ";path=/;"   +    'domain='             + cookieDomain + ';'      ;
                document.cookie = 'userFullName' + "=" + response.fullName + ";" + "10000" + ";path=/;"  +    'domain='          + cookieDomain + ';'     ;
                document.cookie = 'companyName' + "=" + response.companyName + ";" + "10000" + ";path=/;"   +    'domain='           + cookieDomain + ';' ;

                resolve(response.username);
            }, (error) => {
                reject(this._handleError(error));
            });

        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            AuthApi.signIn(email, password)
            .then(response => {
                //adding cookies

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

                document.cookie = 'token' + "=" + response.token + ";" + "10000" + ";path=/;"                   +    'domain='  + cookieDomain + ';'      ; 
                document.cookie = 'rtoken' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 
                document.cookie = 'authUser' + "=" + response.username + ";" + "10000" + ";path=/;"             +    'domain='  + cookieDomain + ';'      ; 
                document.cookie = 'userFullName' + "=" + response.fullName + ";" + "10000" + ";path=/;"         +    'domain='  + cookieDomain + ';'      ; 
                document.cookie = 'companyName' + "=" + response.companyName + ";" + "10000" + ";path=/;"       +    'domain='  + cookieDomain + ';'      ; 
                document.cookie = 'userr' + "=" + response.role + ";" + "10000" + ";path=/;"                    +    'domain='  + cookieDomain + ';'      ; 
                document.cookie = 'permission' + "=" + JSON.stringify(response.permission) + ";" + "10000" + ";path=/;" + 'domain=' + cookieDomain + ';'    ;
 

                if (response.loginBanner) {
                    Swal.fire({
                        /*imageUrl: require("@/assets/images/invite-cropa.jpg"),*/
                        imageUrl: '/api/banner/get/' + response.loginBanner,
                        
                        showCancelButton: false,
                        showConfirmButton: false ,
                        allowOutsideClick: true, 
                        confirmButtonColor: "#34c38f",
                
                        customClass: {
                            popup: 'custom-popup-class',
                            title: 'custom-title-class',
                            cancelButton: 'custom-cancel-button-class',
                            confirmButton: 'custom-confirm-button-class',
                        },
                        backdrop: `
                            rgb(38 50 47 / 88%)
                            center left
                            no-repeat
                        `,
                        onOpen: () => {
                            const modal = Swal.getPopup();
                            modal.style.width = '1100px'; 
                            modal.style.height = '500px'; 
                        }
                    })
                }


                resolve(response.username);
            }, (error) => {
                reject(this._handleError(error));
            }).then(
                
            );
        });
    }

    /**
     * forget Password user with given details
     */
    /*forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }*/

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            AuthApi.logout()
            .then(() => {

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

                //delete cookies

                document.cookie = 'token' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'rtoken' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'userr' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'userFullName' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'companyName' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'authUser' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

                document.cookie = 'drafto' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'draftoc' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

                document.cookie = 'permission' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

                resolve(true);
            }, (error) => {
                reject(this._handleError(error));
            });
        });

        /*return new Promise((resolve, reject) => {
            AuthApi.
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })

        });*/
    }

    setLoggeedInUser = (user) => {
        document.cookie = 'authUser' + "=" + user + ";" + "10000" + ";path=/";
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        /*const authUser = ('; '+document.cookie).split(`; authUser=`).pop().split(';')[0];

        if (!authUser)
            return null;
        return authUser;*/


        const token = ('; '+document.cookie).split(`; token=`).pop().split(';')[0];
        return !token ? null : token
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        //TODO to be fixed later
        // var errorMessage = error.message;
        // return errorMessage;
        console.log(error)
        return  ("Login ou mot de passe erroné")
    }
}


let _fireBaseBackend = null;

const initFirebaseBackend = () => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend();
    }
    return _fireBaseBackend;
}

const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

const refreshToken = (store) => {
    if (store.state.auth.isRefreshing) {
        return store.state.auth.refreshingCall;
    }

    //refresh token from cookie
    const refreshTokenFromCookie = ('; '+document.cookie).split(`; rtoken=`).pop().split(';')[0];
    // store.commit('auth/setRefreshingState', true);
    const refreshingCall = AuthApi.refresh(refreshTokenFromCookie).then((response) => {
        


        var currentDomain = window.location.hostname;
        var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

        //adding cookies
        document.cookie = 'token' + "=" + response.token + ";" + "10000" + ";path=/;"                   +    'domain='  + cookieDomain + ';'      ; 
        document.cookie = 'rtoken' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 
 
        // store.commit('auth/setToken', response.token)
        // store.commit('auth/setRefreshingState', false);
        // store.commit('auth/setRefreshingCall', undefined);
        return Promise.resolve(true);
    // }, (error) => {
    //     return Promise.reject(false);
        }, () => {
        return Promise.reject(false);
                
            }
    
    
    
    );
    // store.commit('auth/setRefreshingCall', refreshingCall);
    return refreshingCall;
}


export { initFirebaseBackend, getFirebaseBackend, refreshToken };
